/**
 * Reset the identified PostHog person on sign-out so the next session starts anonymous.
 * Provider-scoped (uses `usePostHog()`), so it must render inside `<PostHogProvider>`.
 */

import { useEffect, useRef } from "react";
import { usePostHog } from "posthog-js/react";
import { subscribeSession, getSessionSnapshot } from "@lato/client/lib/supabase";
import { POSTHOG_KEY } from "@/lib/posthog";

export function AnalyticsBridge(): null {
  const posthog = usePostHog();
  const prevSession = useRef(getSessionSnapshot());
  useEffect(() => {
    return subscribeSession(() => {
      const session = getSessionSnapshot();
      if (!!prevSession.current !== !!session && !session && POSTHOG_KEY) {
        posthog.reset();
      }
      prevSession.current = session;
    });
  }, [posthog]);
  return null;
}
